export default "__VITE_ASSET__BeoMgJiR__"